<template>
<v-row>
    <v-dialog v-model="isVisible" absolute max-width="400" scrollable>
        <v-card>
            <v-form ref="form">
                <v-card-title class="primary-header pa-3">
                    백테스트 설정 저장
                </v-card-title>
                <v-card-text>
                    <v-text-field label="이름" v-model="name" :rules="nameRules" hide-details></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text" color="primary" @click="save">저 장</v-btn>
                    <v-btn class="white--text" color="red" @click="close">닫 기</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import firebase from 'firebase/app'
import {
    db,
    auth
} from '@/firebase'

export default {
    name: 'save-dialog',
    data() {
        return {
            isVisible: false,
            sort: '',
            name: '',
            nameRules: [
                v => {
                    if (!v) return '이름을 입력해주세요'
                    return true
                },
            ],
            url: ''
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        }
    },
    methods: {
        show(sort, url) {
            this.sort = sort
            this.url = url
            this.isVisible = true
        },
        save() {
            if (!this.$refs.form.validate()) return

            db.collection('users').doc(this.user.id).collection(this.sort).doc().set({
                name: this.name,
                url: this.url
            })

            this.$toasted.show("저장되었습니다")
            this.close()
        },
        close() {
            this.isVisible = false
        },
    }
}
</script>
